import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { UploadFilesComponent } from './upload-files.component';
import { UploadFilesRoutingModule } from './upload-files-routing.module';
import { UploadFilesDetailsComponent } from './components/upload-files-details/upload-files-details.component';
import { UploadFilesViewComponent } from './components/upload-files-view/upload-files-view.component';


@NgModule({
  declarations: [UploadFilesComponent,UploadFilesDetailsComponent,UploadFilesViewComponent],
  imports: [
    CommonModule,
    UploadFilesRoutingModule,
    SharedModule
  ]
})
export class UploadFilesModule { }
